<template>
    <ls-modal :options="modals.threeCutMinimum" @onModalClose="closeModal('threeCutMinimum')">
        <div slot="header">
            <h3 class="ls-align--center ls-color--green ls-margin--top-none">3-cut Minimum</h3>
        </div>

        <div class="grid">
            <div class="grid__col-sm-12">
                <p data-font-size="-1">
                    We're so confident that you'll enjoy our service that, unlike most lawn care
                    companies, we don't require you to sign a long term contract. In fact, we only
                    ask that you commit to three cuts in order to evaluate the service.
                </p>
                <p data-font-size="-1">
                    If you're not pleased with the work being done, simply contact us by phone,
                    email, or app, and we'll be more than happy to address your concerns.
                </p>
            </div>
        </div>

        <div slot="button" class="grid">
            <div class="grid__col-12">
                <div>
                    <button
                        slot="button"
                        class="ls-float-right ls-button ls-button--white"
                        type="button"
                        @click="closeModal('threeCutMinimum')"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    </ls-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as types from '@/store/types';
import lsModal from '@/components/original-mydot/modals/modal/Modal.vue';

export default {
    components: {
        lsModal,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState(['modals']),
    },
    methods: {
        ...mapActions({
            closeModal: types.MODAL__CLOSE_MODAL,
        }),
    },
};
</script>

<style lang="scss"></style>
